<script>
	export let size = '2rem', fill = 'none', stroke = 'white', color = 'inherit';
</script>

<div style='width: {size}; height: {size}; fill: {fill}; stroke: {stroke}; color: {color};'>
	<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>ionicons-v5-a</title><path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48Zm0,319.91a20,20,0,1,1,20-20A20,20,0,0,1,256,367.91Zm21.72-201.15-5.74,122a16,16,0,0,1-32,0l-5.74-121.94v-.05a21.74,21.74,0,1,1,43.44,0Z"/></svg>
</div>

<style>
	div {
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
